<template>
  <!-- <Title title="Orders" /> -->
  <div class="h-full pb-14 w-full flex flex-col">
    <div
      class="flex justify-evenly shadow-inner pb-4 pt-4 bg-gray-50 text-bnb-brown"
    >
      <button
        @click="$store.commit('ordersComponent', 'TrackOrder')"
        :class="[
          $store.state.ordersComponent == 'TrackOrder'
            ? 'bg-bnb-mustard text-xl text-white'
            : 'text-gray-600 bg-white',
        ]"
        class="border shadow-md rounded-md font-bold px-4 py-1"
      >
        Track Order
      </button>

      <button
        @click="$store.commit('ordersComponent', 'MyOrders')"
        :class="[
          $store.state.ordersComponent == 'MyOrders'
            ? 'bg-bnb-mustard text-xl  text-white'
            : 'text-gray-600 bg-white',
        ]"
        class="border font-bold shadow-md rounded-md px-4 py-1"
      >
        My Orders
      </button>
    </div>
    <div class="flex-1 w-full overflow-y-scroll mt-8">
      <component :is="$store.state.ordersComponent" />
    </div>
  </div>
</template>
<script>
import TrackOrder from "@/views/orders/TrackOrder";
import MyOrders from "@/views/orders/MyOrders";
export default {
  components: { TrackOrder, MyOrders },
};
</script>
